var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.863281,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#112347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4502 9.79605V7L7.36328 11.7533L12.4502 16.5066V13.7105C12.4502 13.7105 13.8633 13.4309 16.4068 14.5493C18.9502 15.6678 20.3633 17 20.3633 17C20.3633 17 19.7981 13.7664 17.2546 11.7533C14.7111 9.74013 12.4502 9.79605 12.4502 9.79605Z",
    fill: "#6C2AD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.9c3a509cec88e30faac5c2f39332a750.svg";
export { ForwardRef as ReactComponent };